import React from 'react';
import styles from './Page.module.scss';
import { getClassName } from '@onsolve/utils.get-class-name';
import Header from 'Header/Header';
import Footer from 'Footer/Footer';
import { BrowserRouter } from 'react-router-dom';
const Page = ({ children, className }) => {
    const [rootClass, getChildClass] = getClassName({
        styles,
        rootClass: 'page',
        className,
        modifiers: {
            blue: true,
        },
    });
    const mainContent = (<>
            <div className={getChildClass('mainContainer')}>{children}</div>
        </>);
    return (<BrowserRouter>
            <div className={rootClass}>
                <Header />
                <main className={getChildClass('main')}>{mainContent}</main>
                <Footer />
            </div>
        </BrowserRouter>);
};
export default Page;
